import { ICartLoyalty } from "api/interfaces/shoping-cart.type";
import axios from "fetch-api/fetch-api";

export default function getCartLoyaltyApi() {
  return axios.post<ICartLoyalty>("/get-cart-loyalty");
}
